export default function Layout({ tabs, activeTab, onTabChange, user, onSignOut, children }) {
  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="sticky top-0 z-10 border-b border-border-base bg-bg-primary/90 backdrop-blur px-6 py-4">
        <div className="max-w-screen-xl mx-auto flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-baseline gap-3">
            <h1 className="text-lg font-semibold tracking-tight text-text-primary">
              Action Dashboard
            </h1>
            <span className="text-sm text-text-secondary">{today}</span>
          </div>

          <div className="flex items-center gap-4">
            <span className="text-xs text-text-muted hidden sm:inline">{user.email}</span>
            <button
              onClick={onSignOut}
              className="text-xs text-text-secondary hover:text-text-primary transition"
            >
              Sign out
            </button>
          </div>
        </div>

        {/* Tabs */}
        <nav className="max-w-screen-xl mx-auto mt-4 flex gap-1 bg-bg-input rounded p-1 w-fit">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`px-4 py-1.5 text-sm font-medium rounded transition ${
                activeTab === tab.id
                  ? 'bg-accent-blue text-white'
                  : 'text-text-secondary hover:text-text-primary'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </header>

      {/* Main */}
      <main className="flex-1 max-w-screen-xl w-full mx-auto px-6 py-6 animate-fade-in">
        {children}
      </main>
    </div>
  );
}
